import React, { Component, Fragment } from 'react';
import Form from 'react-jsonschema-form';
import { Button, TableBody, TableRow, TableCell, Box, IconButton } from '@material-ui/core';
import { AccountCircle, Close, Create, EditRounded, CloseRounded, Phone } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { TableLayout } from '../Stock/containers/Layout';
import InputText from '../../../commonModules/interface/form-input-inline';
var    $ = require('jquery');

const isPhoneField = (label, value) => {
    const phoneLabels = /tél|téléphone|phone|mobile/i;
    const phoneValue = /^[\d\s+.-]{6,}$/;
    return value && typeof value === 'string' && phoneLabels.test(label) && phoneValue.test(value.replace(/\s/g, ''));
};

const cleanPhoneNumber = (val) => (String(val).replace(/\D/g, '') || '');

class DisplayUserInfo extends Component{
    state = { }

    render() {
        const { info, update, showUpdateForm } = this.props;
        let infoTmp = [];
        let x = '';
        let i=-1

        for ( x in info){
            i++
            const target = "#collapse"+i;
            if(!x.startsWith("Photo") && x !== "infoInstallation"){
                const val = info[x];
                const showCallIcon = isPhoneField(x, val);
                const telHref = showCallIcon && cleanPhoneNumber(val) ? `tel:+${cleanPhoneNumber(val)}` : null;
                infoTmp.push(
                    <TableRow key={x}>
                        <TableCell component="th" >{x}</TableCell>
                        <TableCell>
                            {val}
                            {telHref && (
                                <IconButton
                                    component="a"
                                    href={telHref}
                                    size="small"
                                    color="primary"
                                    title="Appeler"
                                    style={{ marginLeft: 4, verticalAlign: 'middle' }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <Phone fontSize="small" />
                                </IconButton>
                            )}
                        </TableCell>   
                        {update &&
                            <TableCell>
                                <IconButton 
                                    color="primary" 
                                    onClick={() => this.props.updateTarget( showUpdateForm === target ? "" : target) }
                                >
                                    {showUpdateForm !== target ?
                                        <EditRounded /> :
                                        <CloseRounded />
                                }
                                </IconButton>
                            </TableCell>
                        }
                    </TableRow>
                );
            }
            if(x === "infoInstallation"){
                for (let y in info[x]){
                    const nestedVal = info[x][y];
                    const showCallIconNested = isPhoneField(y, nestedVal);
                    const telHrefNested = showCallIconNested && cleanPhoneNumber(nestedVal) ? `tel:+${cleanPhoneNumber(nestedVal)}` : null;
                    infoTmp.push(
                        <TableRow key={`${x}-${y}`}>
                            <TableCell component="th" >{y}</TableCell>
                            <TableCell>
                                {nestedVal}
                                {telHrefNested && (
                                    <IconButton
                                        component="a"
                                        href={telHrefNested}
                                        size="small"
                                        color="primary"
                                        title="Appeler"
                                        style={{ marginLeft: 4, verticalAlign: 'middle' }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <Phone fontSize="small" />
                                    </IconButton>
                                )}
                            </TableCell>   
                            {update &&
                                <TableCell>
                                    <IconButton 
                                        color="primary" 
                                        onClick={() => this.props.updateTarget( showUpdateForm === target ? "" : target) }
                                    >
                                        {showUpdateForm !== target ?
                                            <EditRounded /> :
                                            <CloseRounded />
                                        }
                                        </IconButton>
                                </TableCell>
                            }
                        </TableRow>
                    );
                }
            }
            if(showUpdateForm === target && update){
                const schemas = this.props.updateInfo(x)
                console.log( schemas);
                infoTmp.push(
                    <TableRow className="dl-horizontal">
                        <TableCell colSpan={3}>
                            <Form
                                schema={schemas[0]}
                                uiSchema={schemas[1]}
                                formData={schemas[2]}
                                onSubmit={this.props.handleSubmit}
                            >
                                <Button type="submit" variant="contained" color="primary" >
                                    Valider
                                </Button>
                            </Form>                                
                        </TableCell>
                    </TableRow>
                );
            }
        }
        return (
            <Box>
                <TableLayout>
                    <TableBody>
                        {infoTmp}
                    </TableBody>
                </TableLayout>
            </Box>
        )
    }
}
export default DisplayUserInfo